import React, { useState } from 'react'
import classNames from 'classnames'
import JSON5 from 'json5'
import { Card, ActionButtonRow } from 'prodigy-ui'
import { createTheming } from 'react-jss'

import Noscript from './noscript'
import classes from '../styles/prodigy.module.sass'

const dummyFunc = () => {}
const NOSCRIPT_PLACEHOLDER = 'This live demo requires JavaScript to be enabled.'

const { ThemeProvider } = createTheming('__PRODIGY_UI_THEME__')
const theme = {
    accept: '#4fd364',
    reject: '#f74c4a',
    ignore: '#b9b9b9',
    undo: '#b9b9b9',
    bgCard: '#fff',
    bgCardSecondary: '#f6f6f6',
    bgCardTertiary: '#ddd',
    bgCardQuaternary: '#aaa',
    bgPage: '#f6f6f6',
    bgOverlay: 'rgba(0, 0, 0, 0.35)',
    bgSidebar: '#54606e',
    bgSidebarDark: '#384451',
    bgHighlight: '#ffe184',
    bgLowlight: '#d9d9d9',
    bgCardTitle: '#583fcf',
    bgProgress: '#fff',
    bgButton: '#b9b9b9',
    bgMeta: '#f6f6f6',
    colorText: '#444',
    colorMeta: '#6e6e6e',
    colorMessage: '#6e6e6e',
    colorSidebar: '#fff',
    colorSidebarHeadline: '#fff',
    colorSidebarLabel: '#b9b9b9',
    colorButton: '#fff',
    colorHighlightLabel: '#583fcf',
    colorCardTitle: '#fff',
    cardBorder: [[1, 'solid', '#ddd']],
    cardShadow: [[1, 1, 5, '#ddd']],
    cardBorderRadius: 0,
    sidebarBorder: 'none',
    fontPrimary: '"Lato", "Trebuchet MS", Roboto, Helvetica, Arial, sans-serif',
    fontSecondary: '"Roboto Condensed", "Arial Narrow", sans-serif',
    buttonSize: 100,
    progressHeight: 10,
    cardMaxWidth: 675,
    cardMinWidth: 300,
    cardMinHeight: 50,
    cardPadding: 20,
    sidebarWidth: 260,
    sidebarBreakpoint: 935,
    imageMaxHeight: 250,
    relationHeight: 200,
    relationHeightWrap: 80,
    largeText: 20,
    mediumText: 20,
    smallText: 20,
    labels: {
        HEAD: '#b3a7ff',
        CHILD: '#e2deff',
        VERB: '#ffa9b8',
        NOUN: '#d1caff',
        PROPN: '#b4e8fc',
        ADJ: '#d3fe7d',
        ADV: '#9effd6',
        CONJ: '#ffa973',
        CCONJ: '#ffa973',
        PUNCT: '#ddd',
    },
}

export const ProdigyCard = ({
    view,
    content = '{}',
    config = '{}',
    noSpace = true,
    gutterBottom = true,
    ...props
}) => {
    const textViews = ['text', 'classification', 'choice']
    const cardClassNames = classNames(classes.card, {
        [classes.cardNoSpace]: !!noSpace,
        [classes.cardNoGutter]: !gutterBottom,
        [classes.cardText]: textViews.includes(view),
    })
    const cardContent = JSON5.parse(content)
    const cardConfig = JSON5.parse(config)
    return (
        <ThemeProvider theme={theme}>
            <Noscript placeholder={NOSCRIPT_PLACEHOLDER} className={classes.placeholderCard}>
                <Card
                    viewId={view}
                    config={cardConfig}
                    content={cardContent}
                    updateQuestion={dummyFunc}
                    handleAnswer={dummyFunc}
                    classes={{ _root: cardClassNames }}
                    {...props}
                />
            </Noscript>
        </ThemeProvider>
    )
}

export default ({
    view,
    content = '{}',
    config = '{}',
    title = 'Prodigy',
    showButtons = true,
    buttons = "['accept', 'reject', 'ignore']",
}) => {
    const [indicateAction, setIndicateAction] = useState(null)
    const handleButtonClick = button => () => {
        setIndicateAction(button)
        setTimeout(() => setIndicateAction(null), 800)
    }
    const buttonNames = JSON5.parse(buttons)
    const handlers = Object.assign({}, ...buttonNames.map(b => ({ [b]: handleButtonClick(b) })))

    return (
        <figure className={classes.root}>
            {title && <h4 className={classes.title}>{title}</h4>}
            <Noscript placeholder={NOSCRIPT_PLACEHOLDER} className={classes.placeholder}>
                <ProdigyCard
                    viewId={view}
                    config={config}
                    content={content}
                    indicateAction={indicateAction}
                    noSpace={false}
                />
                {showButtons && (
                    <ActionButtonRow
                        buttons={buttonNames}
                        handlers={handlers}
                        classes={{ _root: classes.footer }}
                        theme={theme}
                    />
                )}
            </Noscript>
        </figure>
    )
}
